import heartNonSelectedImg from "../../images/heart-non-selected.png";
import heartSelectedImg from "../../images/heart-selected.png";
import brainNonSelectedImg from "../../images/brain-non-selected.png";
import brainSelectedImg from "../../images/brain-selected.png";
import diaphragmNonSelectedImg from "../../images/diaphragm-non-selected.png";
import diaphragmSelectedImg from "../../images/diaphragm-selected.png";
import lungNonSelectedImg from "../../images/lung-non-selected.png";
import lungSelectedImg from "../../images/lung-selected.png";
import spineSelectedImg from "../../images/spine-selected.png";
import spineNonSelectedImg from "../../images/spine-non-selected.png";
import thyroidNonSelectedImg from "../../images/thyroid-non-selected.png";
import thyroidSelectedImg from "../../images/thyroid-selected.png";
import liverNonSelectedImg from "../../images/liver-non-selected.png";
import liverSelectedImg from "../../images/liver-selected.png";
import stomachNonSelectedImg from "../../images/stomach-non-selected.png";
import stomachSelectedImg from "../../images/stomach-selected.png";
import gutNonSelectedImg from "../../images/gut-non-selected.png";
import gutSelectedImg from "../../images/gut-selected.png";
import bonesNonSelectedImg from "../../images/bones-non-selected.png";
import bonesSelectedImg from "../../images/bones-selected.png";
import muscleNonSelectedImg from "../../images/muscle-non-selected.png";
import pancreasNonSelectedImg from "../../images/pancreas-non-selected.png";
import pancreasSelectedImg from "../../images/pancreas-selected.png";
import kidneyNonSelectedImg from "../../images/kidney-non-selected.png";
import kidneySelectedImg from "../../images/kidney-selected.png";

import classes from "./HumanFigureOrgans.module.css";
import DataPointOrgan from "./DataPointOrgan";
import { useSelector } from "react-redux";
import { RootStatePlatform } from "../../store/platform-slice";
import React from "react";

type Props = {
  /**
   * When false, the per-organ DataPointOrgan dots are rendered transparently
   * — the DOM element and its `id={MetricType[id]}` anchor are preserved so
   * line/connector overlays (e.g. Xarrow in BodyMapTab) keep working, but
   * the dot is visually invisible and non-interactive. Used by the
   * consultation's Body Composition view where the figure is purely visual.
   * Defaults to true to preserve existing score-screen behavior.
   */
  showDataPoints?: boolean;
};

// Defined at module scope (NOT inside HumanFigureOrgans) so its component
// reference is stable across renders. An inline definition would be a fresh
// function on every render, causing React to unmount + remount every
// DataPointOrgan when HumanFigureOrgans re-renders (e.g. on system change).
// That tears down the DOM ids that BodyMapTab's Xarrow connectors anchor to
// and produces broken/(0,0) lines.
type DotProps = { showDataPoints: boolean } & React.ComponentProps<
  typeof DataPointOrgan
>;
const Dot = ({ showDataPoints, ...rest }: DotProps) => (
  <DataPointOrgan {...rest} visible={showDataPoints} />
);

const HumanFigureOrgans = ({ showDataPoints = true }: Props = {}) => {
  const selectedSystem = useSelector(
    (state: RootStatePlatform) => state.platform.selectedSystem
  );
  const selectedActiveConnection = useSelector(
    (state: RootStatePlatform) => state.platform.selectedActiveConnection
  );

  return (
    <>
      <div
        className={classes.organImgContainer}
        style={{
          // width: "161px",
          // height: "194px",
          bottom: "208px",
          left: "228px",
        }}
      >
        <img
          src={
            selectedSystem === 6 || selectedActiveConnection === 6
              ? spineSelectedImg
              : spineNonSelectedImg
          }
          className={classes.organImg}
          alt={"lung"}
        />
        <Dot showDataPoints={showDataPoints} id={6} top={"80px"} left={"30px"} position="fix" />
      </div>
      <div
        className={classes.organImgContainer}
        style={{
          width: "87px",
          height: "71px",
          bottom: "475px",
          left: "205px",
        }}
      >
        <img
          id={"brain_image"}
          src={
            selectedSystem === 5 ||
            selectedSystem === 10 ||
            selectedActiveConnection === 5 ||
            selectedActiveConnection === 10
              ? brainSelectedImg
              : brainNonSelectedImg
          }
          className={classes.organImg}
          alt={"brain"}
        />
        <Dot showDataPoints={showDataPoints} id={5} top={"23px"} left={"26px"} position="fix" />
        <Dot showDataPoints={showDataPoints} id={10} top={"43px"} left={"44px"} position="fix" />
        <div
          id={"brain_image_1"}
          style={{ position: "absolute", top: "20px", left: "78px" }}
        />
      </div>
      <div
        className={classes.organImgContainer}
        style={{
          width: "161px",
          height: "194px",
          bottom: "219px",
          left: "168px",
        }}
      >
        <img
          src={
            selectedSystem === 1 || selectedActiveConnection === 1
              ? lungSelectedImg
              : lungNonSelectedImg
          }
          className={classes.organImg}
          alt={"lung"}
        />
        <Dot showDataPoints={showDataPoints} id={1} top={"100px"} left={"45px"} position="fix" />
      </div>

      <div
        className={classes.organImgContainer}
        style={{
          width: "45px",
          height: "36px",
          bottom: "375px",
          left: "226px",
        }}
      >
        <img
          src={
            selectedSystem === 14 || selectedActiveConnection === 14
              ? thyroidSelectedImg
              : thyroidNonSelectedImg
          }
          className={classes.organImg}
          alt={"thyroid"}
        />
        <Dot showDataPoints={showDataPoints} id={14} top={"28px"} left={"29px"} position="fix" />
      </div>
      <div
        className={classes.organImgContainer}
        style={{
          width: "56px",
          height: "90px",
          bottom: "286px",
          left: "264px",
        }}
      >
        <img
          src={
            selectedSystem === 7 || selectedActiveConnection === 7
              ? heartSelectedImg
              : heartNonSelectedImg
          }
          className={classes.organImg}
          alt={"heart"}
        />
        <Dot showDataPoints={showDataPoints} id={7} top={"37px"} left={"35px"} position="fix" />
      </div>
      <div
        className={classes.organImgContainer}
        style={{
          width: "90px",
          height: "90px",
          bottom: "217px",
          left: "204px",
        }}
      >
        <img
          src={
            selectedSystem === 21 || selectedActiveConnection === 21
              ? kidneySelectedImg
              : kidneyNonSelectedImg
          }
          className={classes.organImg}
          alt={"kidney"}
        />
        <Dot showDataPoints={showDataPoints} id={21} top={"34px"} left={"60px"} position="fix" />
      </div>
      <div
        className={classes.organImgContainer}
        style={{ width: "134px", bottom: "195px", left: "182px" }}
      >
        <img
          src={
            selectedSystem === 2 || selectedActiveConnection === 2
              ? diaphragmSelectedImg
              : diaphragmNonSelectedImg
          }
          className={classes.organImg}
          alt={"diaphragm"}
        />
        <Dot showDataPoints={showDataPoints} id={2} top={"30px"} left={"10px"} position="fix" />
      </div>
      <div
        className={classes.organImgContainer}
        style={{ width: "94px", bottom: "170px", left: "193px" }}
      >
        <img
          src={
            selectedSystem === 19 || selectedActiveConnection === 19
              ? liverSelectedImg
              : liverNonSelectedImg
          }
          className={classes.organImg}
          alt={"liver"}
        />
        <Dot showDataPoints={showDataPoints} id={19} top={"45px"} left={"20px"} position="fix" />
      </div>
      <div
        className={classes.organImgContainer}
        style={{ width: "90px", bottom: "180px", left: "213px" }}
      >
        <img
          src={
            selectedSystem === 13 || selectedActiveConnection === 13
              ? stomachSelectedImg
              : stomachNonSelectedImg
          }
          className={classes.organImg}
          alt={"stomach"}
        />
        <Dot showDataPoints={showDataPoints} id={13} top={"25px"} left={"78px"} position="fix" />
      </div>

      <div
        className={classes.organImgContainer}
        style={{ width: "79px", bottom: "158px", left: "205px" }}
      >
        <img
          src={
            selectedSystem === 20 || selectedActiveConnection === 20
              ? pancreasSelectedImg
              : pancreasNonSelectedImg
          }
          className={classes.organImg}
          alt={"pancreas"}
        />
        <Dot showDataPoints={showDataPoints} id={20} top={"33px"} left={"23px"} position="fix" />
      </div>
      <div
        className={classes.organImgContainer}
        style={{
          width: "132px",
          height: "155px",
          bottom: "80px",
          left: "182px",
        }}
      >
        <img
          src={
            selectedSystem === 18 || selectedActiveConnection === 18
              ? gutSelectedImg
              : gutNonSelectedImg
          }
          className={classes.organImg}
          alt={"gut"}
        />
        <Dot showDataPoints={showDataPoints} id={18} top={"65px"} left={"94px"} position="fix" />
      </div>
      <div
        className={classes.organImgContainer}
        style={{ width: "79px", bottom: "93px", left: "334px" }}
      >
        <img
          src={
            selectedSystem === 22 || selectedActiveConnection === 22
              ? bonesSelectedImg
              : bonesNonSelectedImg
          }
          className={classes.organImg}
          alt={"bones"}
        />
        <Dot showDataPoints={showDataPoints} id={22} top={"95px"} left={"20px"} position="fix" />
      </div>
      <img
        id={"muscle_image"}
        src={muscleNonSelectedImg}
        alt={"muscle"}
        className={classes.organImgContainer}
        style={{ width: "56px", bottom: "100px", left: "360px" }}
      />
    </>
  );
};

export default HumanFigureOrgans;
